<template>
  <div id="regions" v-if="region">
    <div class="detail-regions">
      <mapMongolia :location="location"/>
      <p class="capital">{{region.subtitle}}</p>
      <p class="ulaanbaatar">
        {{region.title}}
      </p>
      <p
        class="description"
      >{{region.description}}</p>
    </div>

    <CarouselThemes :locations="[region.id]" />
    <GetTravelInspired :locations="[region.id]"/>
    <Snapshots/>
    <Footerdiv/>
  </div>
</template>

<script>
import mapMongolia from "@/components/MapMongolia";
import CarouselThemes from "@/components/CarouselThemes";
import GetTravelInspired from "@/components/GetTravelInspired";
import Snapshots from "@/components/Snapshots";
import Footerdiv from "@/components/Footer";

export default {
  name: "regions",
  components: {
    mapMongolia,
    CarouselThemes,
    GetTravelInspired,
    Snapshots,
    Footerdiv
  },
  data() {
    return {
      region: null,
      location : null
    };
  },
  mounted() {
    const region = this.$store.state.ref.locations.find(it => it.alias === this.$route.params.name);
    if(region) {
      this.region = region;
      this.location = region.alias;
    }
  }
};
</script>

<style lang="scss" scoped>
#regions {
  .detail-regions {
    padding: 104px 22px 30px;
  }
  .capital {
    font-size: 17px;
  }

  .ulaanbaatar {
    font-size: 25px;
    font-weight: bold;
  }

  .description {
    font-size: 13px;
  }
}
</style>


